import React from "react";
import { DataMessages, useData, useDataEvents, useErrors } from "../hooks/useData";
import { Spinner } from "./Spinner";


export function DataAwareButton(props: {
    children?: any,
    onClick: () => void,
}) {

    const data = useData();
    const errors = useErrors(data);
	const [status, setStatus] = React.useState({
		communicating: false,
	});

	useDataEvents(data, React.useCallback((msg: any) => {
		if (msg.type === DataMessages.API_STATUS) {
			setStatus(msg.status);			
		}
	}, []));

	let spinner;
	if (status.communicating) {
		spinner = <Spinner size="small" />
	}

    return (
        <button
            className="primary flex horiz gap-3"
            disabled={(errors && errors.length > 0) || (data.validateCount === 0) || status.communicating}
            onClick={() => {
                if (props.onClick) props.onClick();
            }}
        >
			{spinner}
			{props.children}
		</button>
    );
}